import { useEffect, useState } from "react";
import { authClient } from "../lib/auth.ts";

type ProviderKey = "google" | "microsoft" | "facebook" | "apple";

const KNOWN: { key: ProviderKey; name: string; bg: string; fg: string }[] = [
  { key: "google",    name: "Google",    bg: "white",   fg: "#0f172a" },
  { key: "microsoft", name: "Microsoft", bg: "#2563eb", fg: "white"   },
  { key: "facebook",  name: "Facebook",  bg: "#1877f2", fg: "white"   },
  { key: "apple",     name: "Apple",     bg: "#000000", fg: "white"   },
];

export function SocialButtons({ callbackURL = "/" }: { callbackURL?: string }) {
  const [enabled, setEnabled] = useState<Set<ProviderKey> | null>(null);

  useEffect(() => {
    fetch("/v1/social-providers", { credentials: "include" })
      .then((r) => r.json())
      .then((d: { providers: string[] }) => setEnabled(new Set(d.providers as ProviderKey[])))
      .catch(() => setEnabled(new Set()));
  }, []);

  if (!enabled) return null;

  // Render only providers whose CLIENT_ID + CLIENT_SECRET are wired up
  // server-side (see /v1/social-providers). Unconfigured providers are
  // hidden entirely rather than shown as "(not configured)" buttons,
  // since users on the production login screen shouldn't see options
  // that visibly don't work.
  const available = KNOWN.filter((p) => enabled.has(p.key));
  if (available.length === 0) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", margin: "0.75rem 0" }}>
      <div className="muted" style={{ fontSize: "0.85rem", textAlign: "center" }}>
        — or continue with —
      </div>
      {available.map((p) => (
        <button
          key={p.key}
          type="button"
          title={`Sign in with ${p.name}`}
          style={{
            background: p.bg,
            color: p.fg,
            border: p.bg === "white" ? "1px solid var(--c-border)" : "0",
            cursor: "pointer",
          }}
          onClick={() => authClient.signIn.social({ provider: p.key, callbackURL })}
        >
          Continue with {p.name}
        </button>
      ))}
    </div>
  );
}
